//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

import { shallowEqual, useSelector  } from 'react-redux'

//  ----------------------------------------------------------------------------
//  Selectors
//  ----------------------------------------------------------------------------

//  -- Examples data ------------------
const selector = (state) => state.quizzes;

export const useQuizzes = () =>{
    const selectedData = useSelector(selector, shallowEqual)
    return selectedData;
}